export const buildCategoryBreadcrumbLabel = (
  pathNames?: string[] | null,
  leafName?: string | null
): string => {
  const path = Array.isArray(pathNames)
    ? pathNames.filter((name) => typeof name === "string" && name.trim().length > 0)
    : [];

  if (path.length > 0) {
    return path.join(" > ");
  }

  return typeof leafName === "string" ? leafName.trim() : "";
};
